import { MorayEastBidOfferPairDTO } from "./bid-offer-pair-dto";

export class MorayEastInstructionDTO {
    public units: string = "";
    public issuedFrom: Date | string = new Date().toISOString().split('T')[0];
    public issuedTo: Date | null = null;
    public dateComment: string = "";
    public isRegular: boolean = true;
    public strikePrice: number = 0;
    public fixedCosts: number = 0;
    public negativePriceTrigger: number = 0;
    public relevantPeriods: string[] = [];
    public bidOfferPairs: MorayEastBidOfferPairDTO[] = [];
    public comments: string = "";
    public status: string ="";
    public isArchived: boolean = false;
    public isAppliedInPPA: boolean = false;
}